import React from "react";

const FarmerFooter = () => {
  return (
    <footer className="bg-white border-t text-center text-gray-500 py-3 text-sm">
      <p>
        © {new Date().getFullYear()} — Empowering Farmers with Data 🌾
      </p>
    </footer>
  );
};

export default FarmerFooter;
